import * as generalApi from '../../../general/api';

export function getCoverage(params) {
  return generalApi.getDeviceCoverage({ cloudType: 'vdc', ...params });
}

export function getCoverageCSV(params) {
  return generalApi.getDeviceCoverageCSV({ cloudType: 'vdc', ...params });
}
